'use client';
import { createMediaQueryContext } from '@s7/base';

const [MediaQueryProvider, useMediaQueryContext] = createMediaQueryContext();

export { MediaQueryProvider, useMediaQueryContext };
//# sourceMappingURL=Footer.context.js.map
